import React from 'react';
export function Footer() {
  return <footer className="bg-navy/95 text-white py-8 px-6 border-t border-white/10" data-id="element-112">
      <div className="max-w-md mx-auto space-y-6 text-center" data-id="element-113">
        <div className="space-y-2" data-id="element-114">
          <h3 className="text-xl font-bold" data-id="element-115">🐾 Kit Veterinario Elite™</h3>
          <p className="text-sm opacity-80 leading-relaxed" data-id="element-116">
            El kit N°1 de planillas profesionales para clínicas y consultorios
            veterinarios de Argentina.
          </p>
        </div>

        <div className="text-sm opacity-70 space-y-1" data-id="element-117">
          <div data-id="element-118">📧 soportetusbeneficios@gmail.com</div>
          <div data-id="element-119">📱 @centralpack.ar</div>
          <div data-id="element-120">🌐 centralpack.shop</div>
        </div>

        <div className="pt-4 border-t border-white/10 space-y-2" data-id="element-121">
          <p className="text-xs opacity-60" data-id="element-122">
            © Kit Veterinario Elite™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-sm italic opacity-80" data-id="element-123">
            🐾 "Más que planillas, es organizar tu clínica como un experto."
          </p>
        </div>
      </div>
    </footer>;
}